export default __webpack_public_path__ + "static/media/Solarhome.59e3bc76.png";